import React from 'react'

const Rules = () => (
  <div style={{marginTop: 80}}>
    The rules are simple:<br /><br />
    You have to guess a secret 5 letter word...<br /><br />
    With every guess, you'll see how many letters match<br /><br />
    <em>For example:</em><br />
    The secret word is "hello"<br />
    You try: "world"<br />
    We tell you there are <strong>2</strong> matching letters<br /><br />
    Use the alphabet on top to keep track<br /><br />
    Happy guessing!<br />
  </div>
)

export default Rules



/** WEBPACK FOOTER **
 ** ./src/components/Rules.js
 **/